import React, { FC } from 'react'
import { Trans, withTranslation } from 'react-i18next'

import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Link from '@material-ui/core/Link'
import Box from '@material-ui/core/Box'

import About from '../about/About'
import Develop from '../develop/Develop'
import Hero from '../hero/Hero'
import { Footer, ScrollTop } from 'shared/components'

type HomeProps = {}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    color: theme.palette.primary.light,
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
}))

const Home: FC<HomeProps> = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h1" className={classes.title}>
            <Trans i18nKey="APP.TITLE" />
          </Typography>

          <Box display={{ xs: 'none', md: 'block' }}>
            <Button
              color="inherit"
              href="#about"
              component={Link}
              className={classes.link}
            >
              <Typography variant="body2" className={classes.title}>
                <Trans i18nKey="ABOUT.TITLE" />
              </Typography>
            </Button>
          </Box>

          <Box display={{ xs: 'none', md: 'block' }}>
            <Button
              color="inherit"
              href="#develop"
              component={Link}
              className={classes.link}
            >
              <Typography variant="body2" className={classes.title}>
                <Trans i18nKey="DEVELOP.TITLE" />
              </Typography>
            </Button>
          </Box>

          <Box display={{ xs: 'none', md: 'block' }}>
            <Button
              color="inherit"
              href="#contact"
              component={Link}
              className={classes.link}
            >
              <Typography variant="body2" className={classes.title}>
                <Trans i18nKey="CONTACT.TITLE" />
              </Typography>
            </Button>
          </Box>

          <Box ml={1}>
            {/* TODO Uncomment if english transaltions is done */}
            {/* <LanguageMenu /> */}
          </Box>
        </Toolbar>
      </AppBar>

      <Hero />

      <Container maxWidth="lg">
        <Box mt={4} mb={4}>
          <About />
          <Develop />
        </Box>

        <ScrollTop />
      </Container>
      <Footer />
    </div>
  )
}

export default withTranslation()(Home)
